<script>
  import { createEventDispatcher } from "svelte";
  import { _ as t } from "svelte-i18n";

  import Title from "./Title.svelte";
  import Button from "./Button.svelte";

  import { currentLang } from "../src/stores.js";

  export let events;

  const dispatch = createEventDispatcher();

  const handleUnregister = (eventId) => {
    dispatch("unregister", { eventId });
  };
</script>

<div class="wrapper">
  <Title>{$t("account.participatingList")}</Title>
  {#each events as event (event._id)}
    <div class="item">
      <div>{event.title[$currentLang]}</div>
      <div>
        <Button on:click={() => handleUnregister(event._id)}>
          {$t("event.unregister")}
        </Button>
      </div>
    </div>
  {/each}
</div>

<style>
  .wrapper {
    margin-top: 48px;
  }

  .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
</style>
